function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as r } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: c , size: l = 24  } = _param, a = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const e = s(), t = c !== null && c !== void 0 ? c : e ? r.colors.inverse : r.colors.neutralHigh;
    return /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, a), {
        children: /* @__PURE__ */ o("path", {
            fill: t,
            d: "M8.819 6.054l.683.695-.16.989c-.078.487.118.966.519 1.252.216.151.462.23.714.23.202 0 .406-.051.591-.155l.815-.445.818.448c.41.224.925.193 1.306-.075a1.28 1.28 0 00.518-1.253l-.163-.991.684-.695c.339-.344.454-.846.302-1.308a1.25 1.25 0 00-1-.849l-.921-.137-.42-.885a1.235 1.235 0 00-1.124-.72 1.24 1.24 0 00-1.126.72l-.417.882-.922.14c-.465.07-.848.395-.997.85a1.28 1.28 0 00.3 1.307zm4.568 1.941l-.002-.002-1.084-.597a.646.646 0 00-.622-.011l-1.129.554.21-1.283a.668.668 0 00-.174-.557l-.888-.986 1.197-.182a.65.65 0 00.515-.361l.585-1.168.558 1.182a.65.65 0 00.47.344l1.244.266-.877.891a.665.665 0 00-.193.574l.193 1.334c0 .002-.003.002-.003.002zm2.3 12.6V17.43h4.927v3.165h-4.927zm-12.305 0V15.05h4.924v5.544H3.382zm11.078-8.58v8.6H9.536V14.72l-.001-.01-.001-.004v-2.691h4.926zm-11.232 9.83h11.39v-.004h6.15c.63 0 1.073-.347 1.073-.818v-4.025c0-.462-.448-.798-1.07-.798H15.69v-4.387c0-.549-.501-1.028-1.073-1.028H9.38c-.569 0-1.07.482-1.07 1.028v2.009H3.228c-.516 0-1.073.344-1.073.899v6.204c0 .496.482.92 1.073.92z"
        })
    }));
}, h = i;
export { h as default };
